import { useRef, useEffect, useCallback } from 'react';

function useEventCallback(callback) {
  const ref = useRef(callback);
  useEffect(() => {
    ref.current = callback;
  });
  return useCallback((...args) => ref.current(...args), []);
}

export { useEventCallback as default };
//# sourceMappingURL=useEventCallback.mjs.map
